// Pure formatting helpers shared by panels. Keeping these in /lib
// rather than in components lets them be testable later without
// pulling in React.

export function maskLocationId(value: string | null | undefined): string {
  if (!value || typeof value !== "string") return "Unknown";
  if (value.length <= 9) return value;
  return `${value.slice(0, 4)}…${value.slice(-4)}`;
}

export function formatRelative(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "Unknown";
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return "Unknown";
  const diffMs = then - now;
  const absMs = Math.abs(diffMs);
  const minutes = Math.round(absMs / 60_000);
  const hours = Math.round(absMs / 3_600_000);
  const days = Math.round(absMs / 86_400_000);
  if (absMs < 60_000) return diffMs >= 0 ? "in <1 min" : "<1 min ago";
  if (minutes < 60) return diffMs >= 0 ? `in ${minutes} min` : `${minutes} min ago`;
  if (hours < 36) return diffMs >= 0 ? `in ${hours}h` : `${hours}h ago`;
  return diffMs >= 0 ? `in ${days}d` : `${days}d ago`;
}

export function formatCountMap(
  map: Record<string, number> | undefined | null,
): string {
  if (!map || typeof map !== "object") return "Unknown";
  const entries = Object.entries(map).filter(([, count]) => Number(count) > 0);
  if (entries.length === 0) return "0";
  return entries.map(([label, count]) => `${count} ${label}`).join(", ");
}

export function formatStatusLabel(value: string | null | undefined): string {
  if (typeof value !== "string" || value.length === 0) return "Unknown";
  return value.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
